import React, {useEffect, useState} from 'react';
import Wrapper from '../../components/Wrapper';
import Cropper from 'react-cropper';
import DashboardHeader from '../../components/DashboardHeader';
import './index.scss';
import {useDispatch, useSelector} from 'react-redux';
import {Helmet} from 'react-helmet';
import {useSaveProfilePhotoMutation} from '../../store/builder/inspections.api';
import {setLoader} from '../../store/builder/reducer';
import {toast} from 'react-toastify';
import 'cropperjs/dist/cropper.css';
import {useLocation} from 'react-router-dom';
import Profile5 from '../../SVG/Profile5';
import ProfileHistory from '../../components/Profile/ProfileHistory';
import FboProfile from '../../components/Profile/FboProfile';
import ProfileFacilityIcon from '../../SVG/ProfileFacilityIcon';
import ProfileFacility from '../../components/ProfileFacility';
import NotAvailable from '../../components/NotAvailable';
import CorrectiveActions from '../../components/Profile/CorrectiveActions';
import CorrectiveActionsIcon from '../../SVG/CorrectiveActions';
import { useUserDetails } from '../../hooks/useUserDetails';
import { useTranslation } from '../../hooks/useTranslation';
  
export default function FBOSettings() {
  const {t} = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const { refetch } = useUserDetails({ enabled: false });
  
  const [currentTab, setCurrentTab] = useState(7);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [chosenPhoto, setChosenPhoto] = useState(null);
  const [cropper, setCropper] = useState();
  const userInfo = useSelector(state => state?.rootReducer?.loginSlice?.user);
  const [currentOrder, setCurrentOrder] = useState(null);

  const [save, {data, isLoading, isError, isSuccess}] =
    useSaveProfilePhotoMutation();

  useEffect(() => {
    if (location?.search?.split('=')[1] === 0) {
      setCurrentTab(0);
    }
  }, [location]);

  useEffect(() => {
    if (userInfo?.agency?.is_settings_complete === false) {
      changeTab(7);
    }
  }, [userInfo]);

  useEffect(() => {
    if (isLoading) {
      dispatch(setLoader(true));
    } else {
      dispatch(setLoader(false));
    }
    if (isSuccess) {
      toast.success(data.message);
    }
  }, [isLoading, isSuccess, isError]);

  useEffect(() => {
    if (typeof chosenPhoto === 'string') {
      setShowModal(true);
    } else {
      setShowModal(false);
    }
  }, [chosenPhoto]);

  function changeTab(tabId) {
    setCurrentTab(tabId);
  }

  function base64ToBlob(base64Data) {
    const contentType = base64Data.substring(5, base64Data.indexOf(';'));
    const byteCharacters = atob(
      base64Data.substring(base64Data.indexOf(',') + 1),
    );
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
      const slice = byteCharacters.slice(offset, offset + 1024);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, {type: contentType});
  }

  const getCropData = () => {
    if (typeof cropper !== 'undefined') {
      const form = new FormData();
      form.append(
        'profile_photo',
        base64ToBlob(cropper.getCroppedCanvas().toDataURL()),
      );
      save(form)
        .then(() => {
          refetch();
          setShowModal(false);  
        })
        .catch(err => {
          toast.error(t('fboSettings.messages.photoUploadError'));
        });
    }
  };

  return (
    <Wrapper>
      <Helmet>
        <title>{t('fboSettings.pageTitle')}</title>
      </Helmet>
      <DashboardHeader title={t('fboSettings.title')} />

      {showModal && (
        <div className='p-modal'>
          <div className='p-modal__content'>
            <div className='p-modal__header'>
              <p></p>
              <h5 className='p-modal__title'>{t('fboProfile.modals.cropImage.title')}</h5>
              <div className='p-modal__close'>
                <img
                  src='/assets/icons/close.svg'
                  alt='close'
                  onClick={() => {
                    setShowModal(false);
                    setChosenPhoto(null);
                  }}
                />
              </div>
            </div>
            <div className='p-modal__cropper'>
              <Cropper
                style={{
                  height: 400,
                  width: '100%',
                }}
                zoomTo={0}
                initialAspectRatio={1}
                preview='.img-preview'
                src={chosenPhoto}
                aspectRatio={1}
                viewMode={0}
                minCropBoxHeight={300}
                minCropBoxWidth={300}
                background={false}
                responsive={true}
                autoCropArea={1}
                checkOrientation={false}
                onInitialized={instance => {
                  setCropper(instance);
                }}
                guides={true}
              />
            </div>
            <div className='p-modal__btns'>
              <label
                htmlFor='profile_photo'
                className='profile__imageBox-upload'
              >
                {t('fboProfile.modals.cropImage.changePhoto')}
              </label>
              <div className='profile__imageBox-upload' onClick={getCropData}>
                {t('fboProfile.modals.cropImage.savePhoto')}
              </div>
            </div>
          </div>
          <div
            className='p-modal__bg'
          ></div>
        </div>
      )}

      {showDeleteModal && (
        <div className='modal'>
          <div className='modal__content'>
            <div className='modal__content-head'>
              <p>{t('fboSettings.modals.deleteCard.title')}</p>
              <img
                className='modal__content-exit'
                src='/assets/icons/close.svg'
                alt='close'
                onClick={() => setShowDeleteModal(false)}
              />
            </div>
            <div
              className='modal__content-body'
              style={{display: 'flex', justifyContent: 'center'}}
            >
              {t('fboSettings.modals.deleteCard.message')}
            </div>
            <div className='modal__content-bottom'>
              <button
                className='close'
                onClick={() => setShowDeleteModal(false)}
              >
                {t('actions.cancel')}
              </button>
              <button className='save danger'>{t('actions.delete')}</button>
            </div>
          </div>
          <div className='modal__bg'></div>
        </div>
      )}
      <div className='profile'>
        <div className='profile__tabs'>
          {userInfo?.role?.name === 'admin' && (
            <div
              className={`profile__tab ${currentTab === 7 ? 'active' : ''}`}
              onClick={() => {
                setCurrentOrder(null);
                changeTab(7);
              }}
            >
              <Profile5 active={currentTab === 7 && true} />
              <p className='profile__tab-name'>{t('fboProfile.title')}</p>
            </div>
          )}
          {userInfo?.role?.name === 'admin' &&
            userInfo?.agency?.is_settings_complete && (
              <div
                className={`profile__tab ${currentTab === 6 ? 'active' : ''}`}
                onClick={() => {
                  setCurrentOrder(null);
                  changeTab(6);
                }}
              >
                <CorrectiveActionsIcon active={currentTab === 6 && true} />
                <p className='profile__tab-name'>{t('fboSettings.correctiveActions.title')}</p>
              </div>
            )}
          {userInfo?.agency?.trial_status === 'equipment' ||
          userInfo?.agency?.trial_status === 'inspection' ? null : (
            <div
              className={`profile__tab ${currentTab === 8 ? 'active' : ''}`}
              onClick={() => {
                setCurrentOrder(null);
                changeTab(8);
              }}
            >
              <ProfileFacilityIcon active={currentTab === 8 && true} />
              <p className='profile__tab-name'>{t('profileFacility.title')}</p>
            </div>
          )}
        </div>

        <div className='profile__box'>
          {currentTab === 7 ? (
            <FboProfile />
          ) : currentTab === 8 ? (
            <ProfileFacility />
          ) : currentTab === 6 ? (
            <CorrectiveActions />
          ) : currentTab === 0 ? (
            (userInfo?.agency?.trial_status === 'equipment' ||
              userInfo?.agency?.trial_status === 'inspection') &&
            !userInfo?.agency?.is_prices_set ? (
              <NotAvailable />
            ) : null
          ) : currentTab === 3 ? (
            userInfo?.agency?.trial_status === 'equipment' ||
            userInfo?.agency?.trial_status === 'inspection' ? (
              <NotAvailable />
            ) : !currentOrder ? (
              <ProfileHistory setCurrentOrder={setCurrentOrder} />
            ) : null
          ) : null}
        </div>
      </div>
    </Wrapper>
  );
}
